import React, { lazy, Suspense } from "react";
import Loader from "../components/layout/Loader";

export function lazyPage(importFn) {
  const Component = lazy(importFn);

  return function LazyPage(props) {
    return (
      <Suspense fallback={<Loader loading />}>
        <Component {...props} />
      </Suspense>
    );
  };
}
